import React from 'react';
import { Typography, useTheme } from '@mui/material';
import { format, addDays } from 'date-fns';

interface TimelineHeaderProps {
    weeks: Date[];
    weekWidth: number;
    headerColumnWidth: number;
}

const TimelineHeader: React.FC<TimelineHeaderProps> = ({
    weeks,
    weekWidth,
    headerColumnWidth,
}) => {
    const theme = useTheme();

    return (
        <div style={{
            display: 'flex',
            position: 'sticky',
            flexDirection: 'row',
            top: 0,
            zIndex: 4,
            backgroundColor: theme.palette.background.default,
            borderBottom: '1px solid #e0e0e0',
            minHeight: '100%',
        }}>
            {/* Header column */}
            <div style={{
                minHeight: '100%',
                position: 'sticky',
                width: headerColumnWidth,
                left: 0,
                top: 0,
                zIndex: 4,
                borderRight: '1px solid #e0e0e0',
                backgroundColor: theme.palette.background.paper,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                padding: '0 20px',
                boxSizing: 'border-box',
                justifyContent: 'flex-start',
            }}>
                <Typography variant="body2" color="text.secondary">
                    Product
                </Typography>
            </div>

            {weeks.map((week, index) => (
                <div key={index}
                    style={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        width: weekWidth,
                        padding: '10px 0px',
                        boxSizing: 'border-box',
                        borderRight: `1px solid ${theme.palette.divider}`,
                    }}
                >
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        padding: '0 10px',
                    }}>
                        <Typography variant="caption" color="text.secondary"
                            sx={{
                                fontWeight: 'bold',
                            }}
                        >
                            {format(week, 'MMMM')}
                        </Typography>

                        <Typography variant="caption" color="text.secondary">
                            Week {format(week, 'w')}
                        </Typography>
                    </div>

                    <div key={index} style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                    }}>
                        {Array.from({ length: 7 }).map((_, dayIndex) => (
                            <div key={dayIndex} style={{
                                width: weekWidth / 7,
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                                <Typography variant="caption" color="text.secondary">
                                    {format(addDays(week, dayIndex), 'd')}
                                </Typography>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default TimelineHeader;
